import styled from 'styled-components';

import { RadioStyle } from '../../../global-styles/form-styles';
import { theme } from '../../../global-styles/colors';

export const RadioCardStyle = styled.div`
  padding: 16px;
  border: 1px solid ${theme.divider_and_border.input_border};
  width: 100%;
  border-radius: 6px;
  cursor: pointer;

  ${RadioStyle}

  .radio-card-top {
    display: flex;
    align-items: center;
    position: relative;
    &__actions {
      display: flex;
      position: absolute;
      right: 0;
      top: -4px;
      &__item {
        padding: 4px;
        margin-left: 8px;
        cursor: pointer;
        width: 24px;
        height: 24px;
        img {
          width: 16px;
        }
      }
    }
  }

  .radio-card-right__text {
    margin-top: 10px;
  }

  .radio-card-left {
    margin-right: 16px;
  }

  &.active {
    background: ${(props) => props.theme.primary.primary10};
    border: 1px solid ${(props) => props.theme.primary.primary50};
    .MuiFilledInput-root:focus,
    .MuiFilledInput-root:hover {
      background-color: none;
    }
  }

  .radio-card-children {
    margin-top: 12px;
  }

  .MuiFilledInput-root:focus,
  .MuiFilledInput-root:hover {
    background-color: white;
  }
  .MuiTextField-root,
  .MuiTextField-root:hover {
    background-color: white;
  }
  .radio-card-icon {
    padding-right: 10px;
  }
`;
